import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { NotificationBadgesStyle, medium, large } from './style'

function NotificationBadges({ count }) {
  let size = ''
  if (count > 9 && count <= 99) {
    size = medium
  } else if (count > 99) {
    size = large
  }
  return (<div className={`${NotificationBadgesStyle} ${size}`}>
    <div className="count-number">{count > 99 ? `99+` : count}</div>
  </div>)
}

export default NotificationBadges;